import { API_GET, API_PUT } from "../config/axiosConfig";

// export async function GetRPMToken() {
//     try {
//         const url = `${process.env.REACT_APP_CORE_API_URI}/web/avatar/rpm/token`;
//         const resp = await API_GET(url);
//         if (resp.status === 200) {
//             return resp.data;
//         }
//         return null;
//     } catch (err) {
//         return null;
//     }
// }
export async function GetUserSettings(userId) {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/users/settings/${userId}`;
        const resp = await API_GET(url);
        if (resp.status === 200) {
            return resp.data;
        }
        return null;
    } catch (error) {
        console.error("Error during user settings fetch:", error);
        return null;
    }
}

// export async function GetRPMGuestUser() {
//     try {
//         const url = `${process.env.REACT_APP_CORE_API_URI}/web/avatar/rpm/guest`;
//         const resp = await API_GET(url);
//         // console.log("Guest User Response:", resp);
//         return resp.data;
//     } catch (err) {
//         return console.log(err);
//     }
// }
// export async function GetRPMGUserToken(rpmUserId) {
//     try {
//         const url = `${process.env.REACT_APP_CORE_API_URI}/web/avatar/rpm/get-rpm-token/${rpmUserId}`;
//         const resp = await API_GET(url);
//         // console.log("Guest User Response:", resp);
//         return resp.data;
//     } catch (err) {
//         return console.log(err);
//     }
// }

export async function UpdateUserSettings(userId, rpmAvatarId = null, readyPlayerMeId = null) {
    try {
        const data = {};

        if (rpmAvatarId !== null && rpmAvatarId !== undefined) {
            data.rpmAvatarId = rpmAvatarId;
        }
        if (readyPlayerMeId !== null && readyPlayerMeId !== undefined) {
            data.readyPlayerMeId = readyPlayerMeId;
        }

        const resp = await API_PUT(`${process.env.REACT_APP_CORE_API_URI}/web/users/settings/${userId}`, data);
        if (resp.status === 200) {
            return resp.data;
        }
    } catch (error) {
        console.error("Error during user data update:", error);
        return error;
    }
}
